import { Icon } from "@vds/icons";
import { useState, useRef } from "react";
import useComponentVisible from "../../global/hooks/useComponentVisible";
import styled from "styled-components";
import AddWidgetModal from "./AddWidgetModal";
import { Button } from "@vds/buttons";
import {
  canAddWidget,
  getNearestEmptyWidget,
} from "../../global/utility/widgetUtils";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import TimerWidgetModal from "./TimerWidgetModal";
import { createPortal } from "react-dom";
import { isRoiWithDeployedStatus } from "../../global/utility/statisticsUtil";

const IconWrapper = styled.div`
  padding: 5px;
  margin-left: 10px;
`;

const SettingsLayout = styled.div`
  min-width: 160px;
  border-radius: 4px;
  position: fixed;
  z-index: 2;
  background-color: white;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  box-shadow: 0px 2px 4px 0px #0000000d;
  box-shadow: 0px 1px 10px 0px #0000001f;
  border-radius: 6px;
`;

const SettingsTabCell = styled.div`
  // width: 160px;
  display: flex;
  padding: 16px;
  gap: 8px;
  border-bottom: 1px solid;
  border-bottom-color: lightgray;
  background-color: ${({ isLightGrayBackground }) =>
    isLightGrayBackground ? "#f6f6f6" : "#ffffff"};
  border-radius: 6px;
`;

const SettingsOptionText = styled.div`
  font-family: Verizon-NHG-eDS;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
`;

const WidgetSettings = ({ setEditMode, saveClicked }) => {
  const [showModal, setShowModal] = useState(false);
  const [showTimerModal, setShowTimerModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const settingsButtonRef = useRef(null);
  const [portalPosition, setPortalPosition] = useState({ top: 0, left: 0, display: "none" });
  const widgetConfig = useSelector((state) => state.widgetReducer.widgetConfig);
  const cvAppConfiged = useSelector((state) => state.polygonRoiReducer?.roiListWithCvapps?.filter(isRoiWithDeployedStatus));
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  useEffect(() => {
    if (!showModal) setIsComponentVisible(false);
  }, [showModal]);

  useEffect(() => {
    if (isComponentVisible && settingsButtonRef.current) {
      const rect = settingsButtonRef.current.getBoundingClientRect();
      setPortalPosition({
        top: rect.bottom + 8,
        right: "4%",
        display: "block"
      });
    }
  }, [isComponentVisible]);

  const widgetAdded = () => {
    setShowModal(false);
  };
  const widgetTimer = () => {
    setShowTimerModal(false);
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        {isEditMode && (
          <Button
            size="small"
            use="primary"
            data-testid="dashboard_widgetEditSaveButton"
            onClick={() => {
              setEditMode(false);
              setIsEditMode(false);
              saveClicked();
            }}
          >
            Save
          </Button>
        )}
        {
          <IconWrapper
            ref={settingsButtonRef}
            data-testid="dashboard_widgetSettingsButton"
            onClick={() => {
              if (!isEditMode) setIsComponentVisible(true);
            }}
          >
            <Icon
              name="settings"
              color={isEditMode ? "#D8DADA" : "#000000"}
              size="medium"
            />
          </IconWrapper>
        }
      </div>
      <AddWidgetModal
        showModal={showModal}
        setShowModal={setShowModal}
        widgetAdded={widgetAdded}
        index={getNearestEmptyWidget(widgetConfig)}
        cvAppConfigedList = {cvAppConfiged}
      />
      <TimerWidgetModal
        showTimerModal={showTimerModal}
        setShowTimerModal={setShowTimerModal}
        widgetTimer={widgetTimer}
      />
      {isComponentVisible &&
        createPortal(
          <SettingsLayout
            ref={ref}
            style={{
              top: `${portalPosition.top}px`,
              right: `${portalPosition.right}`,
              display: portalPosition.display
            }}
          >
            <SettingsTabCell
              data-testid="dashboard_widgetAddButton"
              onClick={() => {
                // if (canAddWidget(widgetConfig)) {
                setShowModal(true);
                // }
              }}
            >
              <Icon name="plus" color="#000000" size="medium" />
              <SettingsOptionText>Add widget</SettingsOptionText>
            </SettingsTabCell>
            <SettingsTabCell
              data-testid="dashboard_widgetEditButton"
              onClick={() => {
                setIsComponentVisible(false);
                setEditMode(true);
                setIsEditMode(true);
              }}
            >
              <Icon name="menu" color="#000000" size="medium" />
              <SettingsOptionText>Edit widget</SettingsOptionText>
            </SettingsTabCell>
            <SettingsTabCell
              data-testid="dashboard_widgetChangeTimeRangeButton"
              onClick={() => {
                setShowTimerModal(true);
              }}
            >
              <Icon name="timer" color="#000000" size="medium" />
              <SettingsOptionText>Change time range</SettingsOptionText>
            </SettingsTabCell>
          </SettingsLayout>,
          document.body
        )}
    </>
  );
};

export default WidgetSettings;
